module.exports = __webpack_public_path__ + "web/img/sign-40.d2effbd6.png";